"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentExclusionTypes = void 0;
const AssignmentExclusion = {
    none: 'none',
    hard: 'hard',
    soft: 'soft',
};
exports.AssignmentExclusionTypes = Object.keys(AssignmentExclusion);
//# sourceMappingURL=AssignmentExclusion.js.map